var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnonces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_358",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.2 37.2",
    style: {
      enableBackground: "new 0 0 37.2 37.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D29B4D;}\n\t.st1{fill:#5F8A8B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3942-3",
    className: "st0",
    d: "M23.3,18.6c-0.3,0-0.6-0.3-0.6-0.6v0v-4.1h-0.6c-0.3,0-0.6-0.3-0.6-0.6 c0-0.3,0.3-0.6,0.6-0.6h1.2c0.3,0,0.6,0.3,0.6,0.6v0v3.4l4.3-3.8c0.1-0.1,0.2-0.1,0.4-0.1h7c0.3,0,0.6-0.3,0.6-0.6V1.7 c0-0.3-0.3-0.6-0.6-0.6H19.2c-0.3,0-0.6,0.3-0.6,0.6v8.7c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6V1.7c0-1,0.8-1.7,1.7-1.7 h16.3c1,0,1.7,0.8,1.7,1.7v10.5c0,1-0.8,1.7-1.7,1.7h-6.8l-5.1,4.5C23.5,18.5,23.4,18.6,23.3,18.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3943-3",
    className: "st1",
    d: "M34.9,31.4c-0.3,0-0.6-0.3-0.6-0.6v0V17.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6 v13.4C35.5,31.1,35.2,31.4,34.9,31.4C34.9,31.4,34.9,31.4,34.9,31.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3944-3",
    className: "st1",
    d: "M2.3,31.4c-0.3,0-0.6-0.3-0.6-0.6v0V11c0-1.6,1.3-2.9,2.9-2.9h10.2c0.3,0,0.6,0.3,0.6,0.6 c0,0.3-0.3,0.6-0.6,0.6H4.7c-1,0-1.7,0.8-1.7,1.7v19.8C2.9,31.1,2.6,31.4,2.3,31.4C2.3,31.4,2.3,31.4,2.3,31.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3945-3",
    className: "st1",
    d: "M33.1,37.2H4.1c-2.2,0-4.1-1.8-4.1-4.1c0-0.3,0.3-0.6,0.6-0.6h0h14c0.3,0,0.6,0.3,0.6,0.6v0 v0.6h7v-0.6c0-0.3,0.3-0.6,0.6-0.6h0h14c0.3,0,0.6,0.3,0.6,0.6v0C37.2,35.4,35.4,37.2,33.1,37.2z M1.2,33.7C1.5,35.1,2.7,36,4.1,36 h29.1c1.4,0,2.6-1,2.8-2.3H23.3v0.6c0,0.3-0.3,0.6-0.6,0.6h0h-8.1c-0.3,0-0.6-0.3-0.6-0.6v0v-0.6H1.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3946-3",
    className: "st0",
    d: "M24.4,30.8c-0.3,0-0.6-0.2-0.6-0.6c0,0-0.2-2.6-2-3.6L18,25c-1.9,0.7-3.9,0.7-5.8,0 l-3.8,1.6c-1.8,0.9-2,3.5-2,3.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.1,0.2-3.3,2.6-4.6l0,0l4.1-1.7 c0.2-0.1,0.3-0.1,0.5,0c1.7,0.7,3.6,0.7,5.3,0c0.2-0.1,0.3-0.1,0.5,0l4.1,1.7l0,0c2.5,1.2,2.6,4.4,2.6,4.6 C25,30.5,24.8,30.8,24.4,30.8C24.5,30.8,24.5,30.8,24.4,30.8L24.4,30.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3947-3",
    className: "st0",
    d: "M16.9,22.7c-0.3,0-0.6-0.3-0.6-0.6c0-0.2,0.1-0.4,0.3-0.5c1.4-0.9,1.5-1.4,1.6-2.9 c0-0.1,0-0.2,0-0.3c0.2-0.8,0.1-1.6-0.2-2.4c-0.4-0.6-0.9-1.1-1.6-1.3c-0.8-0.3-1.7-0.3-2.5,0c-0.7,0.2-1.3,0.7-1.6,1.3 c-0.3,0.8-0.4,1.6-0.2,2.4c0,0.1,0,0.2,0,0.3c0.2,1.4,0.2,1.9,1.6,2.9c0.3,0.2,0.3,0.5,0.2,0.8s-0.5,0.3-0.8,0.2l0,0 c-1.4-0.7-2.2-2.2-2.1-3.7c0-0.1,0-0.2,0-0.3c-0.2-1-0.1-2.1,0.4-3.1c0.5-0.9,1.3-1.6,2.3-1.9c1-0.3,2.2-0.3,3.2,0 c1,0.3,1.8,1,2.3,1.9c0.4,1,0.6,2,0.4,3.1c0,0.1,0,0.2,0,0.3c0,1.5-0.8,3-2.1,3.7C17.1,22.6,17,22.7,16.9,22.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnonces);
export default __webpack_public_path__ + "static/media/annonces.7cd93a77f22b50e7a48490fc7ba27e78.svg";
export { ForwardRef as ReactComponent };